<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12 col-lg-9 mx-auto">
        <p>
          O objetivo do portal RPA é credenciar e criar um acesso diferenciado para empresas de multicalculo que realizam as cotações ou acesso a outras funcionalidades do Portal Tokio com RPA (Robotic Process Automation).
          <br><strong>OBS: Disponível apenas para o produto Auto.</strong>
        </p>
      </div>
    </div>
    <!-- passo 1 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>1° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Acesse o Portal Parceiros e clique no menu "Eu Corretor"!
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-1.png" alt="">
      </div>
    </div>
    <!-- passo 2 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>2° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Na sessão de "Integrações e Serviços" clique em "Adesão Multicalculo".
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-2.png" alt="">
      </div>
    </div>
    <!-- passo 3 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>3° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Selecione o produto Automóvel e o Acelerador (Robô) desejado e clique em “Aderir”.
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-rpa-3.png" alt="">
      </div>
    </div>
    <!-- passo 4 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>4° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Será apresentada uma mensagem de confirmação e o corretor receberá via e-mail a aprovação ou recusa da solicitação.
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-rpa-4.png" alt="">
      </div>
    </div>
    <!-- passo 5 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>5° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Dentro de alguns minutos, a corretora receberá em seu e-mail de contato os dados de acesso ao Portal Tokio RPA.
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-rpa-5.png" alt="">
      </div>
    </div>
    <!-- passo 6 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>6° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          O corretor deverá utilizar o usuário e senha recebidos no e-mail para acessar o Portal Tokio RPA. 
          <br><strong>OBS: No primeiro acesso a senha deverá ser alterada.</strong> 
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-rpa-6.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }
};
</script>
